angular.module 'zc.core'

.factory 'SessionRecoverer', ($q, $injector, $location, $timeout, $window, localStorageService) ->
  PREFLIGHT_TIMEOUT_MINUTES = 30
  _lastRequestTime = moment()
  _preflightInProgress = false
  # Before we do any other requests, make sure that we do /api/environment
  # request first. This updates remember_user_token.
  _environmentRequestDone = false

  updateRememberUserToken = () ->
    # We must make sure that this will be executed only once!!!
    #
    # Since each remember_user_token update causes Time.new() to be added as
    # part of HttpOnly cookie token (on rails side), if two requests are sent
    # simultaneously, the one that arrives first will update the token, and
    # second will already have old information.
    #
    # This will cause token to reset and subsequent requests forward to
    # /users/sign_in
    return _preflightInProgress if _preflightInProgress

    Devise = $injector.get 'Devise'
    _preflightInProgress = Devise.getCurrentUser({force: true, isPreflight: true})
    .then (res) ->
      _preflightInProgress = false
      res
    .catch (err) ->
      _preflightInProgress = false
      $q.reject err

  preflightRequest = (config) ->
    Environment = $injector.get 'Environment'

    if !_environmentRequestDone
      if /\/api\/environment/.test(config.url)
        # Let only environment request pass, so that remember_user_token
        # refreshes the session. If we let multiple requests through
        # simultaneously rails works for first one, but since session has
        # changed when rails processes subsequent ones, session will be
        # forcefully logged out
        return config
      else if /\/templates\/.*\.html$/.test(config.url) ||
          /\/i18n\/locale-ja\.json/.test(config.url)
        # Let also template and localization requests pass
        # TODO: these are not really necessary!
        # In reality, there is no reason to let these pass before /api/environment,
        # but it would complicate tests so let them pass. Rails also does not apply
        # strange devise magic regarding to these, so no problem.
        return config
      else
        # Ensure that /environment is first request!!
        return Environment.get()
          .then () ->
            _environmentRequestDone = true
            return config

    if config.isPreflight && /\/users\/show_current/.test(config.url)
      # If this is preflight request, let it pass
      return config

    # In case of _zenclerk_session has expired, or memcached value has expired,
    # we must do preflight request to update remember_user_token from server.
    preflightTimeoutMinutes = localStorageService.get('_zc_preflight_timeout_minutes') || PREFLIGHT_TIMEOUT_MINUTES
    if _lastRequestTime.isAfter(moment().subtract(preflightTimeoutMinutes, 'minutes'))
      return config

    updateRememberUserToken()
    .then (res) ->
      config

  success = (response, req) ->
    Devise = $injector.get 'Devise'
    $httpOnce = $injector.get '$httpOnce'
    # Update the lastrequesttime in case of successful request
    _lastRequestTime = moment()

    # The below is especially for facade. The above preflightRequest should
    # handle this case, but there is still rare possibility that this happens.
    # (When first request after a long inactivity happens to be facade instead
    # of rails)
    if response.data?.login_expired
      # If login has expired, make forced request to rails get_current_user api
      # which will get the new user
      Devise.getCurrentUser({force: true})
      .then (user) ->
        # After devise request resolves, repeat the request with new
        # login token
        config = _.assignIn {}, response.config
        config.headers["X-LOGIN-TOKEN"] = user.login_token

        # do not cache, or we just get same result...
        config.cache = false

        config.repeatCounter ||= 0
        config.repeatCounter++

        # if same request happened 2 times, give up and go to signIn page
        if config.repeatCounter < 2
          $httpOnce(config)
        else
          $state = $injector.get '$state'
          $window.location = $state.href("users.signIn", { absolute: true })

      .catch (err) ->
        # remember_user_token update also failed so forward to sign_in
        $window.location.href = "/users/sign_in"

    else
      response

  return {
    request: preflightRequest,
    response: success
  }



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/interceptors/session_recoverer.coffee